var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-processing-indicator"},[_vm._t("default",[_vm._v("Please wait while we process your request ...")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }